import { fetchGuestCountry } from './country';
export const DEFAULT_LOCALE = 'en-US';
export const LOCALES = {
    EN_GB: 'en-GB',
    EN_US: 'en-US',
    EN_AU: 'en-AU',
    EN_CA: 'en-CA'
};
export const SUPPORTED_LOCALES = Object.values(LOCALES);
export const COUNTRY_TO_LOCALE = {
    US: LOCALES.EN_US,
    CA: LOCALES.EN_CA,
    GB: LOCALES.EN_GB,
    AU: LOCALES.EN_AU
};
export async function fetchGuestLocale(onError) {
    try {
        const country = await fetchGuestCountry();
        return ((country && COUNTRY_TO_LOCALE[country.toUpperCase()]) ||
            DEFAULT_LOCALE);
    }
    catch (error) {
        onError?.(error);
        return getBrowserLocale();
    }
}
export function getBrowserLocale() {
    const langs = navigator.languages?.length
        ? navigator.languages
        : [navigator.language];
    for (const lang of langs) {
        const [normalized] = Intl.getCanonicalLocales(lang);
        if (SUPPORTED_LOCALES.includes(normalized)) {
            return normalized;
        }
    }
    return DEFAULT_LOCALE;
}
//# sourceMappingURL=locale.js.map